const STRING_CAP = 50;

/**
 * Once-per-error dedup covering object and string errors: objects by identity, strings by value in a capped
 * set. Saturation fails closed (reports "seen") so distinct messages can never log without bound.
 */
export function createSeenRegistry() {
	const seenObjects = new WeakSet<object>();
	const seenStrings = new Set<string>();
	return {
		seen(error: unknown): boolean {
			if (typeof error === "object" && error !== null) {
				if (seenObjects.has(error)) {
					return true;
				}
				seenObjects.add(error);
				return false;
			}
			if (typeof error === "string") {
				if (seenStrings.has(error) || seenStrings.size >= STRING_CAP) {
					return true;
				}
				seenStrings.add(error);
				return false;
			}
			return false;
		},
	};
}
